<template>
  <div class="image-crop" @mousemove="onMouseMove" @mouseleave="onMouseUp" @mouseup="onMouseUp">
    <!-- {{ corners }}=={{ isFixedRatio }} -->
    <div class="image-crop-container" :style="containerStyle">
      <img class="crop-image" ref="cropCanvas" :src="appState.OriginUrl" />
      <div class="crop-mask abs-full"></div>
      <div class="crop-box" :style="cropBoxStyle" @mousedown="onCropBoxMouseDown">
        <div class="crop-box-inner abs-full"></div>
        <!-- 触角 -->
        <div
          v-for="item in corners"
          :key="item"
          class="crop-knob"
          :class="`crop-knob-${item}`"
          @mousedown="e => onKnobMouseDown(e, item)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { formatterPx } from '@/utils';
import useCrop from './useCrop';

const store = useStore();
const appState = computed(() => store.state.app);
const canvasScale = computed(() => appState.value.canvasScale);
const cropCanvas = ref(null);

const {
  isFixedRatio,
  corners,
  cropBoxPosition,
  cropBoxStyle,
  onCropBoxMouseDown,
  onCropBoxMouseMove,
  onCropBoxMouseUp,
  onKnobMouseDown,
  onKnobMouseMove,
  onKnobMouseUp,
  onMouseUp,
  onMouseMove,
  cropBoxUnZoomedPosition,
} = useCrop();

const containerStyle = computed(() => {
  const { canvasWidth, canvasHeight } = appState.value.editorSize;
  return {
    width: formatterPx(canvasWidth * canvasScale.value),
    height: formatterPx(canvasScale.value * canvasHeight),
  };
});

onMounted(() => {
  const { canvasWidth, canvasHeight } = appState.value.editorSize;
  // cropCanvas.value.width = canvasWidth;
  // cropCanvas.value.height = canvasHeight;
  // const ctx = cropCanvas.value.getContext('2d');
  // ctx.drawImage($pureImageResult, 0, 0);
});
</script>

<style lang="less" scoped>
.crop-knob {
  position: absolute;
  width: 30px;
  height: 30px;
  &::before,
  &::after {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    width: 30px;
    height: 3px;
    background: rgba(#000, 0.8);
  }
  &::after {
    width: 3px;
    height: 30px;
  }
  &-tl {
    left: -3px;
    top: -3px;
    cursor: nwse-resize;
    z-index: 1;
  }
  &-tr {
    right: -3px;
    top: -3px;
    cursor: nesw-resize;
    &::after {
      left: auto;
      right: 0;
    }
  }
  &-bl {
    left: -3px;
    bottom: -3px;
    cursor: nesw-resize;
    &::before {
      top: auto;
      bottom: 0;
    }
  }
  &-br {
    right: -3px;
    bottom: -3px;
    cursor: nwse-resize;
    &::after {
      left: auto;
      right: 0;
    }
    &::before {
      top: auto;
      bottom: 0;
    }
  }
  &-ml {
    cursor: ew-resize;
  }
  &-ml,
  &-mr {
    left: -3px;
    top: 50%;
    transform: translate(0, -50%);
    &:before {
      display: none;
    }
  }
  &-mr {
    left: auto;
    right: -3px;
    cursor: ew-resize;
    z-index: 1;
    &::after {
      left: auto;
      right: 0;
    }
  }
  &-tc {
    cursor: ns-resize;
  }
  &-tc,
  &-bc {
    left: 50%;
    top: -3px;
    transform: translate(-50%, 0);
    &:after {
      display: none;
    }
  }
  &-bc {
    top: auto;
    bottom: -3px;
    cursor: ns-resize;
    &::before {
      top: auto;
      bottom: 0;
    }
  }
}
.crop-mask {
  background: rgba(#fff, 0.5);
  pointer-events: none;
}
.crop-box {
  position: absolute;
  cursor: move;
  background-repeat: no-repeat;
}
.crop-box-inner {
  border: 1px dashed rgba(#000, 0.8);
}
.image-crop {
  height: 100%;
  overflow: hidden;
}
.crop-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
}
.image-crop-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
